/* First-visit language selection. Shopify handles geolocation; no third-party IP service. */
(() => {
  'use strict';
  const config = document.getElementById('fp-localization-config');
  if (!config) return;
  let settings;
  try { settings = JSON.parse(config.textContent); } catch (_) { return; }
  const manualKey = 'fp-language-choice-v1';
  const visitKey = 'fp-language-visit-v1';
  const current = settings.language;
  const confirmation = {
    en: 'Changing language or region reloads this page. Your selected photo and unsaved personalization will need to be entered again. Continue?',
    de: 'Beim Wechsel von Sprache oder Region wird diese Seite neu geladen. Dein ausgewähltes Foto und deine noch nicht gespeicherte Personalisierung müssen erneut eingegeben werden. Fortfahren?',
    fr: 'Changer de langue ou de région recharge cette page. Vous devrez sélectionner à nouveau votre photo et saisir votre personnalisation non enregistrée. Continuer ?'
  };
  function hasPersonalization() {
    return Array.from(document.querySelectorAll('input[name^="properties["], textarea[name^="properties["]')).some(input =>
      input.type === 'file' ? input.files && input.files.length > 0 : input.type !== 'hidden' && String(input.value || '').trim() !== ''
    );
  }
  // Called by the theme's existing desktop and mobile language/country selectors.
  window.fpConfirmLocalization = function(form) {
    if (hasPersonalization() && !window.confirm(confirmation[current] || confirmation.en)) {
      const languageInput = form.querySelector('[name="language_code"]');
      const countryInput = form.querySelector('[name="country_code"]');
      if (languageInput) languageInput.value = current;
      if (countryInput) countryInput.value = countryInput.defaultValue;
      return false;
    }
    const language = form.querySelector('[name="language_code"]')?.value || current;
    try { localStorage.setItem(manualKey, language); sessionStorage.setItem(visitKey, '1'); } catch (_) { /* Preference storage is optional for manual selection. */ }
    return true;
  };
  if (!settings.auto || settings.cartCount > 0 || settings.designMode) return;
  if (!['index', 'product', 'collection', 'page', 'list-collections', 'search'].includes(settings.pageType)) return;
  const url = new URL(window.location.href);
  // Localized ad links and explicit language choices always win.
  if (current !== 'en' || url.searchParams.has('locale') || url.searchParams.has('language') || url.searchParams.has('preview_theme_id')) return;
  try {
    if (document.referrer && new URL(document.referrer).origin === url.origin) return;
    if (localStorage.getItem(manualKey) || sessionStorage.getItem(visitKey)) return;
    sessionStorage.setItem(visitKey, '1');
    if (sessionStorage.getItem(visitKey) !== '1') return;
  } catch (_) { return; } // Without loop protection, leave the visitor's language unchanged.
  let interacted = hasPersonalization();
  const stop = () => { interacted = true; };
  ['pointerdown', 'keydown', 'input', 'change', 'submit', 'touchstart'].forEach(type => document.addEventListener(type, stop, {capture: true, once: true}));
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 1500);
  const started = Date.now();
  fetch(settings.root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', {
    credentials: 'same-origin', signal: controller.signal
  }).then(response => {
    if (!response.ok) throw new Error('Location unavailable');
    return response.json();
  }).then(data => {
    const language = {DE: 'de', FR: 'fr'}[data?.detected_values?.country?.handle];
    if (!language || !settings.available.includes(language) || language === current || interacted || hasPersonalization() || Date.now() - started > 1500) return;
    const form = document.getElementById('fp-auto-localization');
    if (!form) return;
    const languageInput = form.querySelector('[name="language_code"]');
    const returnInputs = form.querySelectorAll('[name="return_to"]');
    if (!languageInput || !returnInputs.length) return;
    languageInput.value = language;
    // Preserve the product, variant, search and ad attribution. Do not change market/currency.
    // Shopify can add its own return_to field. Keep every copy consistent.
    returnInputs.forEach(input => { input.value = url.pathname + url.search + url.hash; });
    HTMLFormElement.prototype.submit.call(form);
  }).catch(() => { /* Detection is nonessential: shopping remains usable in the existing language. */ })
    .finally(() => clearTimeout(timer));
})();
